import { render, staticRenderFns } from "./show.schedule-items.page.vue?vue&type=template&id=53326bd4&scoped=true&"
import script from "./show.schedule-items.page.vue?vue&type=script&lang=js&"
export * from "./show.schedule-items.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53326bd4",
  null
  
)

export default component.exports